import Custom404Page from "./404";

export function NotFoundPage() {
  return <Custom404Page />;
}
